import { FC, ReactNode } from 'react';

import { timeComparator } from '@/apps/mwd-v2/utils/timeComparator';
import {
  geefDienstregelpuntVoorConflict,
  geefInzetVoorConflict,
  geefPerronSpoorVoorConflict,
} from '@/domain/conflict/conflictUtils';
import { useConflicten } from '@/state/selectors/useConflicten';
import { dayOfWeekWithTime } from '@/utils/dateUtils';
import { geefTijdstipVoorConflict, vindEersteInzet } from '@/views/ddp/utils/conflict';

import styles from '@/apps/mwd-v2/components/MwdTooltip/MwdTooltip.module.css';
import perronStyles from '@/apps/mwd-v2/components/MwdTooltip/PerronLengteConflictTooltip.module.css';

const fractionOptions = { minimumFractionDigits: 1, maximumFractionDigits: 1 };

type TooltipPerronLengteConflictProps = {
  werklijnId: string;
  arrowPosition: any;
  fallback: ReactNode;
};
const PerronLengteConflictTooltipContent: FC<TooltipPerronLengteConflictProps> = ({
  arrowPosition,
  werklijnId,
  fallback,
}) => {
  const { conflictenView: conflicten } = useConflicten(['PERRONLENGTE'], [werklijnId]);
  const eerstePerronlengteConflict = conflicten
    .slice()
    .sort((a, b) => timeComparator(a, b, geefTijdstipVoorConflict))
    .at(0);

  const eerstePerronlengteConflictElement = eerstePerronlengteConflict?.elementen
    ? vindEersteInzet(eerstePerronlengteConflict)
    : undefined;

  const treinlengte = eerstePerronlengteConflictElement?.treinLengte?.toLocaleString('nl-NL', fractionOptions) ?? '0';
  const perronLengte = eerstePerronlengteConflictElement?.perronLengte?.toLocaleString('nl-NL', fractionOptions) ?? '0';
  const overschrijding =
    eerstePerronlengteConflictElement?.lengteOverschrijding?.toLocaleString('nl-NL', fractionOptions) ?? '0';

  return (
    <div
      data-testid='left-legend-perronlengte-conflict-tooltip'
      className={arrowPosition === 'bottom' ? styles.legendLeftBottomTooltipStyle : styles.legendLeftTopTooltipStyle}
    >
      {eerstePerronlengteConflict ? (
        <div className={perronStyles.containerStyle}>
          <div className={perronStyles.titleStyle}>Perronlengteconflict</div>
          <div className={perronStyles.infoStyle}>
            <span>Trein {geefInzetVoorConflict(eerstePerronlengteConflict)},</span>
            <span>{geefDienstregelpuntVoorConflict(eerstePerronlengteConflict)}</span>
            <span>{dayOfWeekWithTime(geefTijdstipVoorConflict(eerstePerronlengteConflict))}</span>
          </div>
          <div className={perronStyles.lengtesStyle}>
            <span>Treinlengte totaal:</span>
            <span>{treinlengte} m.</span>
          </div>
          <div className={perronStyles.lengtesStyle}>
            <span>Lengte {geefPerronSpoorVoorConflict(eerstePerronlengteConflict, 'tooltip')}:</span>
            <span>{perronLengte} m.</span>
          </div>
          <div className={perronStyles.lengtesStyle}>
            <strong>Overschrijding:</strong>
            <strong className={perronStyles.overschrijdingStyle}>-{overschrijding} m.</strong>
          </div>
        </div>
      ) : (
        fallback
      )}
    </div>
  );
};

export default PerronLengteConflictTooltipContent;
